import { C } from './SiteChrome';

/**
 * The question-and-answer accordion. One component for the homepage and for
 * every blog post, so the two cannot drift apart. The class names are the ones
 * the landing page's fade-in and hover styles look for.
 */
const FaqList = ({ faqs }) => (
    <div className="mq-faqlist" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {faqs.map((f, i) => (
            <details key={i} className="mq-lift" style={{ background: C.faqBg, border: `1px solid ${C.faqBorder}`, borderRadius: 24, padding: '24px 28px' }}>
                <summary style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, cursor: 'pointer', listStyle: 'none' }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.deep }}>{f.q}</div>
                    <div style={{ width: 30, height: 30, borderRadius: 999, background: '#e3f3e8', color: C.primary, fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>+</div>
                </summary>
                <div style={{ marginTop: 14, fontSize: 14.5, lineHeight: 1.6, color: C.bodyOnWhite, whiteSpace: 'pre-line' }}>{f.a}</div>
            </details>
        ))}
    </div>
);

export default FaqList;
